import { render } from "./SelectApprove.vue?vue&type=template&id=3911242a&scoped=true&ts=true"
import script from "./SelectApprove.vue?vue&type=script&lang=ts"
export * from "./SelectApprove.vue?vue&type=script&lang=ts"

import "./SelectApprove.vue?vue&type=style&index=0&id=3911242a&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3911242a"]])

export default __exports__